/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _button_to_add_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ajouter un Media' }],
    'fr',
);

export function button_to_add(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _button_to_add_fr.format(args) as unknown as string;
    }

    return _button_to_add_fr.format(args) as unknown as string;
}

const _menu_edit_the_portfolio_media_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Modifier' }],
    'fr',
);

export function menu_edit_the_portfolio_media(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu_edit_the_portfolio_media_fr.format(args) as unknown as string;
    }

    return _menu_edit_the_portfolio_media_fr.format(args) as unknown as string;
}

const _menu_delete_the_portfolio_media_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Supprimer' }],
    'fr',
);

export function menu_delete_the_portfolio_media(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu_delete_the_portfolio_media_fr.format(args) as unknown as string;
    }

    return _menu_delete_the_portfolio_media_fr.format(args) as unknown as string;
}

const _menu_to_up_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Remonter le média' }],
    'fr',
);

export function menu_to_up(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu_to_up_fr.format(args) as unknown as string;
    }

    return _menu_to_up_fr.format(args) as unknown as string;
}

const _menu_to_down_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Descendre le média' }],
    'fr',
);

export function menu_to_down(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu_to_down_fr.format(args) as unknown as string;
    }

    return _menu_to_down_fr.format(args) as unknown as string;
}

const _modal_add_portfolio_media_title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nouveau Media' }],
    'fr',
);

export function modal_add_portfolio_media_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _modal_add_portfolio_media_title_fr.format(args) as unknown as string;
    }

    return _modal_add_portfolio_media_title_fr.format(args) as unknown as string;
}

const _modal_edit_portfolio_media_title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Modifier le Media' }],
    'fr',
);

export function modal_edit_portfolio_media_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _modal_edit_portfolio_media_title_fr.format(args) as unknown as string;
    }

    return _modal_edit_portfolio_media_title_fr.format(args) as unknown as string;
}

const _confirm_modal_delete_portfolio_media_message_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voulez-vous vraiment supprimer ce média de votre portfolio ?' }],
    'fr',
);

export function confirm_modal_delete_portfolio_media_message(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _confirm_modal_delete_portfolio_media_message_fr.format(
            args,
        ) as unknown as string;
    }

    return _confirm_modal_delete_portfolio_media_message_fr.format(
        args,
    ) as unknown as string;
}

const _toast_portfolio_media_saved_success_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Média enregistré avec succès' }],
    'fr',
);

export function toast_portfolio_media_saved_success(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _toast_portfolio_media_saved_success_fr.format(args) as unknown as string;
    }

    return _toast_portfolio_media_saved_success_fr.format(args) as unknown as string;
}

const _input_video_label_fr = new IntlMessageFormat([{ type: 0, value: 'Vidéo' }], 'fr');

export function input_video_label(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _input_video_label_fr.format(args) as unknown as string;
    }

    return _input_video_label_fr.format(args) as unknown as string;
}

const _input_photo_label_fr = new IntlMessageFormat([{ type: 0, value: 'Photo' }], 'fr');

export function input_photo_label(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _input_photo_label_fr.format(args) as unknown as string;
    }

    return _input_photo_label_fr.format(args) as unknown as string;
}

const _toast_media_upload_error_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Une erreur est survenue lors de l'envoi des médias, veuillez réessayer.",
        },
    ],
    'fr',
);

export function toast_media_upload_error(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _toast_media_upload_error_fr.format(args) as unknown as string;
    }

    return _toast_media_upload_error_fr.format(args) as unknown as string;
}

const _form_label_media_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Photo / Vidéo' }],
    'fr',
);

export function form_label_media(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _form_label_media_fr.format(args) as unknown as string;
    }

    return _form_label_media_fr.format(args) as unknown as string;
}

const _form_label_title_fr = new IntlMessageFormat([{ type: 0, value: 'Titre' }], 'fr');

export function form_label_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _form_label_title_fr.format(args) as unknown as string;
    }

    return _form_label_title_fr.format(args) as unknown as string;
}

const _form_label_desc_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Description' }],
    'fr',
);

export function form_label_desc(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _form_label_desc_fr.format(args) as unknown as string;
    }

    return _form_label_desc_fr.format(args) as unknown as string;
}

const _form_label_link_fr = new IntlMessageFormat([{ type: 0, value: 'Lien' }], 'fr');

export function form_label_link(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _form_label_link_fr.format(args) as unknown as string;
    }

    return _form_label_link_fr.format(args) as unknown as string;
}

const _portfolio_management_page_title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mon Portfolio' }],
    'fr',
);

export function portfolio_management_page_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _portfolio_management_page_title_fr.format(args) as unknown as string;
    }

    return _portfolio_management_page_title_fr.format(args) as unknown as string;
}
